module.exports = __webpack_public_path__ + "images/confirmation/call-center-agent.jpg";